module.exports = __webpack_public_path__ + "img/_box_appointment.3aebf064.svg";